import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type * as Types from '../../codegen/types.js';

const defaultOptions = {} as const;
export type UpdateCustomerMarketingPreferencesMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerMarketingPreferencesInput;
}>;

export type UpdateCustomerMarketingPreferencesMutation = {
  __typename?: 'Mutation';
  updateCustomerMarketingPreferences: boolean;
};

export const UpdateCustomerMarketingPreferencesDocument = gql`
  mutation updateCustomerMarketingPreferences($input: UpdateCustomerMarketingPreferencesInput!) {
    updateCustomerMarketingPreferences(input: $input)
  }
`;
export type UpdateCustomerMarketingPreferencesMutationFn = Apollo.MutationFunction<
  UpdateCustomerMarketingPreferencesMutation,
  UpdateCustomerMarketingPreferencesMutationVariables
>;

/**
 * __useUpdateCustomerMarketingPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMarketingPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMarketingPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMarketingPreferencesMutation, { data, loading, error }] = useUpdateCustomerMarketingPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMarketingPreferencesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerMarketingPreferencesMutation,
    UpdateCustomerMarketingPreferencesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomerMarketingPreferencesMutation,
    UpdateCustomerMarketingPreferencesMutationVariables
  >(UpdateCustomerMarketingPreferencesDocument, options);
}
export type UpdateCustomerMarketingPreferencesMutationHookResult = ReturnType<
  typeof useUpdateCustomerMarketingPreferencesMutation
>;
export type UpdateCustomerMarketingPreferencesMutationResult =
  Apollo.MutationResult<UpdateCustomerMarketingPreferencesMutation>;
export type UpdateCustomerMarketingPreferencesMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerMarketingPreferencesMutation,
  UpdateCustomerMarketingPreferencesMutationVariables
>;
